import ResourcesScreen from '@screens/Resources/ResourcesScreen';

export default ResourcesScreen;
